var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sessionIsAMatch)?_c('div',{staticStyle:{"margin-top":"5vh"}},[_c('p',{staticStyle:{"font-size":"12px","margin-left":"5vw"}},[_vm._v("(*) - played <90mins ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }